export default __webpack_public_path__ + "static/media/cappy-symbol-pos.9f2d7abc.png";